// extracted by mini-css-extract-plugin
export default {"container":"KBvubc7F","card":"A7yCyXue","header":"L3xMj5Ys","title":"t49asVKT","label":"hbv_qOcJ","name":"PmXXf33X","buttons":"I2Ulrsqb","form":"WczDmjhp"};